/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_OkInputs */

const en_us2_profile_update_ok = /** @type {(inputs: Profile_Update_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got it`)
};

const pt_br2_profile_update_ok = /** @type {(inputs: Profile_Update_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entendi`)
};

const es_419_profile_update_ok = /** @type {(inputs: Profile_Update_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entendido`)
};

const pt_pt2_profile_update_ok = /** @type {(inputs: Profile_Update_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entendido`)
};

const fr_fr2_profile_update_ok = /** @type {(inputs: Profile_Update_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compris`)
};

const de_de2_profile_update_ok = /** @type {(inputs: Profile_Update_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verstanden`)
};

const it_it2_profile_update_ok = /** @type {(inputs: Profile_Update_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ok`)
};

/**
* | output |
* | --- |
* | "Got it" |
*
* @param {Profile_Update_OkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_ok = /** @type {((inputs?: Profile_Update_OkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_OkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_ok(inputs)
	if (locale === "es-419") return es_419_profile_update_ok(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_ok(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_ok(inputs)
	if (locale === "de-DE") return de_de2_profile_update_ok(inputs)
	if (locale === "it-IT") return it_it2_profile_update_ok(inputs)
	return en_us2_profile_update_ok(inputs)
});
export { profile_update_ok as "profile.update_ok" }